<template>
  <div class="hello">
    <div class='backgroundBottom'></div>

    <div class="desc">
      나랑 가장 잘 어울리는<br>빛을 골라 보세요
    </div>
    <div>
      <splide 
        :options="splideOptions"
        ref="splide"
        @splide:moved="onChanged"
        @splide:click="onClick">
        <splide-slide
          class="mb-5"
          v-for="image of images" 
          :key="image">
          <div class='back-border' :class="currActive(image)">
            <img class="d-block w-100" :src="image.url" :alt="image.alt">
          </div>
        </splide-slide>
      </splide>
    </div>

    <div>
    
    </div>
    <button class="fixed-bottom next-button" @click="nextPage">
      이걸로 할래요
    </button>
  </div>
</template>

<script>
import { data } from '../data'

export default {
  name: 'SelectBackgroundView',
  data: () => {
    return {
      images: data.image,
      currIndex: 0,

      splideOptions: {
        gap    : '15px',
        arrows : false,
        padding: {
          right: '3rem',
          left : '3rem',
        },
      },
    }
  },
  mounted: function () {
    console.log('mounted')
  },
  methods: {
    currActive: function (image) {
      return image.index == this.currIndex ? 'active' : ''
    },
    onChanged: function (_, newIndex) {
      this.currIndex = newIndex
    },
    onClick: function (e, index) {
      const splide = this.$refs.splide
      splide.go(index.index)
    },
    nextPage: function () {
      localStorage.selectBackground = this.currIndex;
      
      this.$router.push('/select-object')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  background: #000;
}

.backgroundBottom {
  position: fixed;
  width: 100%;
  height: 50%;
  background: #000;
  z-index: -10;
  bottom: 0;
}

.next-button {
  text-align: center;
  padding: 16px;

  margin: 16px;
  font-size: 16px;
  font-weight: bold;
  background: #DAE000;
  color: #000;
  border-radius: 8px;
  height: 56px;
}

.desc {
  padding-top: 47px;
  padding-bottom: 32px;

  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #fff;
}

.back-border {
  width: 100%;
  height: 250px;
  /* border: 3px solid #3Ab54B;
  border-radius: 8px;
  background: #3Ab54B; */
  border: 0px solid #000;
  border-radius: 8px;
  background: #515151;
      
  vertical-align: middle;
  display: table-cell;
}

.back-border.active {
  border: 3px solid #000;
}


</style>
